"use client";

import { motion } from "motion/react";
import { usePathname } from "next/navigation";
import * as React from "react";
import { TRANSITION } from "./motion-tokens";

export interface PageTransitionProps {
  children: React.ReactNode;
}

// AnimatePresence + Next.js App Router don't compose: when `pathname` changes,
// the App Router replaces children synchronously while AnimatePresence is mid-
// swap, leaving the freshly-mounted motion.div stuck at exit state
// (opacity:0, translateY(-4px)) until the user refreshes — i.e. white screen
// after every client navigation. Solution: drop AnimatePresence and let the
// `key={pathname}` remount fade the new tree in directly. The previous tree's
// exit animation is invisible during a route swap anyway because the App
// Router has already removed it from the layout.
export function PageTransition({ children }: PageTransitionProps) {
  const pathname = usePathname();
  return (
    <motion.div
      key={pathname}
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={TRANSITION.fast}
    >
      {children}
    </motion.div>
  );
}
